import React, { useRef, useState, useEffect } from "react";

import { Field, FieldArray } from "formik";
import MaskedInput from "react-text-mask";

import { IoTrash } from "react-icons/io5";

import {
  Box,
  Flex,
  HStack,
  Text,
  Divider,
  Image,
  Grid,
  GridItem,
  Button,
  Icon,
  FormControl,
  FormLabel,
  FormErrorMessage,
  Input,
} from "@chakra-ui/react";

import DadosGeograficosService from "../../../../../main/services/DadosGeograficosService";
import { numeroEndereco, cnpjMaskPattern } from "../../../../utils/masks";
import CustomSelect from "../../../../components/CustomSelect";
import LabelComHint from "../../../../components/LabelComHint";
import {
  HINT_CNPJ_MANTENEDORA,
  HINT_CNPJ_PROPRIO,
} from "../../../../../helpers/hints";
import ErrorMessage from "../../../../components/CustomErrorMessage";

const Identificacao = ({
  formProps,
  defaultImage,
  setDefaultImage,
  defaultEstado,
  defaultMunicipio,
  invalidCNPJ,
  existCNPJ,
  message,
}) => {
  const inputRef = useRef();
  const [file, setFile] = useState(null);
  const [bairros, setBairros] = useState({ options: [], isLoading: false });
  const [isFocused, setIsFocused] = useState(false);
  const [isBlur, setIsBlur] = useState(false);
  const [municipios, setMunicipios] = useState({
    options: [],
    isLoading: false,
  });
  const [estados, setEstados] = useState({ options: [], isLoading: false });

  useEffect(() => {
    if (!!formProps.values.estadoId) {
      setMunicipios((prevState) => ({ ...prevState, isLoading: true }));
      DadosGeograficosService.pesquisarMunicipios(
        formProps.values.estadoId.id,
      ).then((res) => {
        setMunicipios({ options: res.data, isLoading: false });
        if (defaultEstado) {
          if (defaultEstado.id !== formProps.values.estadoId.id) {
            formProps.setFieldValue("municipioId", "");
            formProps.setFieldValue("bairroId", "");
          }
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formProps.values.estadoId]);

  useEffect(() => {
    if (!!formProps.values.municipioId) {
      setBairros((prevState) => ({ ...prevState, isLoading: true }));
      DadosGeograficosService.pesquisarBairros(
        formProps.values.municipioId.id,
      ).then((res) => {
        setBairros({ options: res.data, isLoading: false });
        if (defaultMunicipio) {
          if (defaultMunicipio.id !== formProps.values.municipioId.id) {
            formProps.setFieldValue("bairroId", "");
          }
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formProps.values.municipioId]);

  const fileHandler = (file) => {
    let reader = new FileReader();
    reader.onloadend = () => {
      setFile({
        file: reader.result,
      });
    };
    reader.readAsDataURL(file);
  };

  const handleGetEstados = () => {
    setEstados({ ...estados, isLoading: true });
    DadosGeograficosService.getEstados().then((res) => {
      setEstados({ options: res.data, isLoading: false });
    });
  };

  return (
    <Flex
      flexDir="column"
      mt="15px"
      pl="15px"
      pr="30px"
      py="20px"
      bgColor="#FFF"
      borderRadius="8px"
    >
      <Text
        color="#169499"
        fontWeight="700"
        fontSize="14px"
        lineHeight="19.6px"
      >
        {"Identificação do Serviço de Acolhimento".toUpperCase()}
      </Text>
      <Divider mt="10px" orientation="horizontal" />
      <Flex
        flexDir={{ base: "column", lg: "row" }}
        w="100%"
        mt="20px"
        alignItems="center"
      >
        <Flex
          w={{ base: "100%", lg: "30%" }}
          alignItems="center"
          justifyContent="center"
        >
          <Field name="logomarca">
            {({ field, form }) => (
              <FormControl
                isInvalid={form.errors.logomarca && form.touched.logomarca}
                id="logomarca"
                d="flex"
                flexDir="column"
                alignItems="center"
                justifyContent="center"
              >
                {defaultImage || file ? (
                  <Image
                    borderRadius="full"
                    boxSize="135px"
                    src={file ? file.file : defaultImage + "?" + Date.now()}
                    alt={file ? file.file.name : "Logomarca"}
                    onError={() => setDefaultImage("")}
                    fit="cover"
                  />
                ) : (
                  <Box boxSize="135px" bgColor="#C4C4C4" borderRadius="full" />
                )}
                <FormLabel
                  color="#5F6377"
                  fontWeight="500"
                  fontSize="14px"
                  lineHeight="19.6px"
                  textAlign="center"
                  htmlFor="logomarca"
                  m="0px"
                >
                  Logomarca
                </FormLabel>
                <Input
                  type="file"
                  accept="image/*"
                  name="logomarca"
                  id="logomarca"
                  backgroundColor="#F9FAFB"
                  d="none"
                  ref={inputRef}
                  onChange={(event) => {
                    form.setFieldValue(
                      field.name,
                      event.currentTarget.files[0],
                    );
                    fileHandler(event.currentTarget.files[0]);
                  }}
                />
                <HStack alignItems="center" mt="5px">
                  <Button
                    id="button-buscar-imagem"
                    color="#FFF"
                    backgroundColor="#169499"
                    fontWeight={500}
                    fontSize="13px"
                    lineHeight="21.6px"
                    _hover={{ bg: "#169499" }}
                    onClick={() => inputRef.current.click()}
                  >
                    Buscar Imagem
                  </Button>
                  {(file || defaultImage) && (
                    <Icon
                      aria-label="Excluir imagem"
                      color="#9EA1AE"
                      as={IoTrash}
                      boxSize="25px"
                      _hover={{ cursor: "pointer" }}
                      onClick={() => {
                        setFile(null);
                        form.setFieldValue(field.name, null);
                        inputRef.current.value = "";
                        setDefaultImage("");
                      }}
                    />
                  )}
                </HStack>
                <FormErrorMessage>{form.errors.logomarca}</FormErrorMessage>
              </FormControl>
            )}
          </Field>
        </Flex>
        <Flex w={{ base: "100%", lg: "100%" }} flexDir="column" flex={1}>
          <Field name="nomeFantasia">
            {({ field, form }) => (
              <FormControl
                isInvalid={
                  form.errors.nomeFantasia && form.touched.nomeFantasia
                }
                id="nomeFantasia"
              >
                <FormLabel
                  color="#5F6377"
                  fontWeight="500"
                  fontSize="14px"
                  lineHeight="19.6px"
                  htmlFor="nomeFantasia"
                >
                  Nome Fantasia*
                </FormLabel>
                <Input
                  {...field}
                  h="42px"
                  name="nomeFantasia"
                  id="nomeFantasia"
                  backgroundColor="#F9FAFB"
                  autoComplete="off"
                  border="1px solid #D7D8DE"
                  placeholder="Informe o Nome Fantasia"
                />
                <FormErrorMessage>{form.errors.nomeFantasia}</FormErrorMessage>
              </FormControl>
            )}
          </Field>
          <Field name="razaoSocial">
            {({ field, form }) => (
              <FormControl
                mt="25px"
                isInvalid={form.errors.razaoSocial && form.touched.razaoSocial}
                id="razaoSocial"
              >
                <FormLabel
                  color="#5F6377"
                  fontWeight="500"
                  fontSize="14px"
                  lineHeight="19.6px"
                  htmlFor="razaoSocial"
                >
                  Razão Social
                </FormLabel>
                <Input
                  {...field}
                  h="42px"
                  name="razaoSocial"
                  id="razaoSocial"
                  backgroundColor="#F9FAFB"
                  autoComplete="off"
                  border="1px solid #D7D8DE"
                />
                <FormErrorMessage>{form.errors.razaoSocial}</FormErrorMessage>
              </FormControl>
            )}
          </Field>
        </Flex>
      </Flex>
      <Grid mt="20px" templateColumns="repeat(6, 1fr)" gap="25px" rowGap="20px">
        <GridItem colSpan={{ base: 6, sm: 6, lg: 2 }}>
          <Field name="cnpj">
            {({ field, form }) => (
              <FormControl
                isInvalid={form.errors.cnpj && form.touched.cnpj}
                id="cnpj"
              >
                <LabelComHint
                  htmlFor="cnpj"
                  hint={HINT_CNPJ_PROPRIO}
                >
                  CNPJ próprio do serviço
                </LabelComHint>
                <Input
                  {...field}
                  h="42px"
                  name="cnpj"
                  id="cnpj"
                  isDisabled={
                    !!form.values.cnpjReferencia && !form.values.cnpj
                  }
                  backgroundColor="#F9FAFB"
                  autoComplete="off"
                  border="1px solid #D7D8DE"
                  placeholder="Informe o CNPJ próprio do serviço"
                  onFocus={() => setIsFocused(false)}
                  guide={false}
                  onChange={(e) => {
                    // Normaliza para maiúsculas
                    const upperValue = e.target.value.toUpperCase();
                    form.setFieldValue('cnpj', upperValue);
                  }}
                  mask={cnpjMaskPattern}
                  as={MaskedInput}
                  onChange={(e) => {
                    if (e.target.value.replace(/\D/g, "").length === 0) {
                      form.setFieldValue("cnpj", "");
                      return;
                    }
                    field.onChange(e);
                  }}
                  onBlur={(e) => {
                    setIsBlur(false);

                    if (e.target.value.replace(/\D/g, "").length === 0) {
                      form.setFieldValue("cnpj", "");
                    }
                  }}
                />
                <FormErrorMessage>{form.errors.cnpj}</FormErrorMessage>

                {!form.errors.cnpj &&
                  form.values.cnpj &&
                  !isFocused &&
                  !invalidCNPJ &&
                  !isBlur && (
                    <Text color="red" opacity={0.8} mt={2} fontSize="12px">
                      Informar um CNPJ válido
                    </Text>
                  )}
                {!form.errors.cnpj &&
                  form.values.cnpj &&
                  existCNPJ &&
                  invalidCNPJ &&
                  !isFocused &&
                  !isBlur && (
                    <Text color="red" opacity={0.8} mt={2} fontSize="12px">
                      {message ? message : ""}
                    </Text>
                  )}
              </FormControl>
            )}
          </Field>
        </GridItem>
        <GridItem colSpan={{ base: 6, sm: 6, lg: 2 }}>
          <Field name="cnpjReferencia">
            {({ field, form }) => (
              <FormControl
                isInvalid={
                  form.errors.cnpjReferencia && form.touched.cnpjReferencia
                }
                id="cnpjReferencia"
              >
                <LabelComHint
                  htmlFor="cnpjReferencia"
                  hint={HINT_CNPJ_MANTENEDORA}
                >
                  CNPJ da entidade mantenedora
                </LabelComHint>
                <Input
                  {...field}
                  h="42px"
                  name="cnpjReferencia"
                  id="cnpjReferencia"
                  isDisabled={
                    !!form.values.cnpj && !form.values.cnpjReferencia
                  }
                  backgroundColor="#F9FAFB"
                  autoComplete="off"
                  border="1px solid #D7D8DE"
                  placeholder="Informe o CNPJ da entidade mantenedora"
                  guide={false}
                  mask={[
                    /\d/,
                    /\d/,
                    ".",
                    /\d/,
                    /\d/,
                    /\d/,
                    ".",
                    /\d/,
                    /\d/,
                    /\d/,
                    "/",
                    /\d/,
                    /\d/,
                    /\d/,
                    /\d/,
                    "-",
                    /\d/,
                    /\d/,
                  ]}
                  as={MaskedInput}
                  onChange={(e) => {
                    if (e.target.value.replace(/\D/g, "").length === 0) {
                      form.setFieldValue("cnpjReferencia", "");
                      return;
                    }
                    field.onChange(e);
                  }}
                  onBlur={(e) => {
                    field.onBlur(e);

                    if (e.target.value.replace(/\D/g, "").length === 0) {
                      form.setFieldValue("cnpjReferencia", "");
                    }
                  }}
                />
                <FormErrorMessage>
                  {form.errors.cnpjReferencia}
                </FormErrorMessage>
              </FormControl>
            )}
          </Field>
        </GridItem>
        <GridItem colSpan={{ base: 6, sm: 6, lg: 2 }}>
          <Field name="site">
            {({ field, form }) => (
              <FormControl
                isInvalid={form.errors.site && form.touched.site}
                id="site"
              >
                <FormLabel
                  color="#5F6377"
                  fontWeight="500"
                  fontSize="14px"
                  lineHeight="19.6px"
                  htmlFor="site"
                >
                  Site
                </FormLabel>
                <Input
                  {...field}
                  h="42px"
                  name="site"
                  id="site"
                  backgroundColor="#F9FAFB"
                  autoComplete="off"
                  border="1px solid #D7D8DE"
                  placeholder="Informe o site"
                  onChange={(e) => {
                    formProps.setFieldValue(
                      "site",
                      e.target.value.toLowerCase(),
                    );
                  }}
                />
                <FormErrorMessage>{form.errors.site}</FormErrorMessage>
              </FormControl>
            )}
          </Field>
        </GridItem>
        <GridItem colSpan={{ base: 6, sm: 6, lg: 2 }}>
          <Field name="estadoId">
            {({ field, form }) => (
              <FormControl
                name="estadoId"
                isInvalid={form.errors.estadoId && form.touched.estadoId}
                id="estadoId"
              >
                <FormLabel
                  color="#5F6377"
                  fontWeight="500"
                  fontSize="14px"
                  lineHeight="19.6px"
                  htmlFor="estadoId"
                >
                  Estado*
                </FormLabel>
                <CustomSelect
                  isInvalid={form.errors.estadoId && form.touched.estadoId}
                  value={formProps.values.estadoId || ""}
                  searchable={true}
                  getOptionLabel={(option) => option.nome}
                  getOptionValue={(option) => option.id}
                  autoload={false}
                  isLoading={estados.isLoading}
                  options={estados.options}
                  placeholder="Escolha o Estado"
                  onChange={(value) => {
                    formProps.setFieldValue("estadoId", value);
                  }}
                  onFocus={
                    estados.options.length === 0 ? handleGetEstados : null
                  }
                />
                <FormErrorMessage>{form.errors.estadoId}</FormErrorMessage>
              </FormControl>
            )}
          </Field>
        </GridItem>
        <GridItem colSpan={{ base: 6, sm: 6, lg: 2 }}>
          <Field name="municipioId">
            {({ field, form }) => (
              <FormControl
                name="municipioId"
                isInvalid={form.errors.municipioId && form.touched.municipioId}
                id="municipioId"
              >
                <FormLabel
                  color="#5F6377"
                  fontWeight="500"
                  fontSize="14px"
                  lineHeight="19.6px"
                  htmlFor="municipioId"
                >
                  Cidade*
                </FormLabel>
                <CustomSelect
                  isInvalid={
                    form.errors.municipioId && form.touched.municipioId
                  }
                  value={formProps.values.municipioId || ""}
                  searchable={true}
                  getOptionLabel={(option) => option.nome}
                  getOptionValue={(option) => option.id}
                  autoload={false}
                  isLoading={municipios.isLoading}
                  options={municipios.options}
                  placeholder="Escolha a Cidade"
                  onChange={(value) => {
                    formProps.setFieldValue("municipioId", value);
                  }}
                />
                <FormErrorMessage>{form.errors.municipioId}</FormErrorMessage>
              </FormControl>
            )}
          </Field>
        </GridItem>
        <GridItem colSpan={{ base: 6, sm: 6, lg: 2 }}>
          <Field name="bairroId">
            {({ field, form }) => (
              <FormControl
                isInvalid={form.errors.bairroId && form.touched.bairroId}
                id="bairroId"
              >
                <FormLabel
                  color="#5F6377"
                  fontWeight="500"
                  fontSize="14px"
                  lineHeight="19.6px"
                  htmlFor="bairroId"
                >
                  Bairro
                </FormLabel>
                <CustomSelect
                  isClearable={true}
                  value={formProps.values.bairroId || ""}
                  searchable={true}
                  getOptionLabel={(option) => option.nome}
                  getOptionValue={(option) => option.id}
                  autoload={false}
                  isLoading={bairros.isLoading}
                  options={bairros.options}
                  placeholder="Escolha o Bairro"
                  onChange={(value) => {
                    formProps.setFieldValue("bairroId", value ? value : "");
                  }}
                />
                <FormErrorMessage>{form.errors.bairroId}</FormErrorMessage>
              </FormControl>
            )}
          </Field>
        </GridItem>
        <GridItem colSpan={{ base: 6, sm: 6, lg: 4 }}>
          <Field name="logradouro">
            {({ field, form }) => (
              <FormControl
                isInvalid={form.errors.logradouro && form.touched.logradouro}
                id="logradouro"
              >
                <FormLabel
                  color="#5F6377"
                  fontWeight="500"
                  fontSize="14px"
                  lineHeight="19.6px"
                  htmlFor="logradouro"
                >
                  Logradouro* (Rua, Avenida, Travessa, Estrada, etc)
                </FormLabel>
                <Input
                  {...field}
                  h="42px"
                  name="logradouro"
                  id="logradouro"
                  backgroundColor="#F9FAFB"
                  autoComplete="off"
                  border="1px solid #D7D8DE"
                  placeholder="Rua, Avenida, Travessa, Estrada, etc"
                />
                <FormErrorMessage>{form.errors.logradouro}</FormErrorMessage>
              </FormControl>
            )}
          </Field>
        </GridItem>
        <GridItem colSpan={{ base: 6, sm: 6, lg: 2 }}>
          <Field name="numeroResidencia">
            {({ field, form }) => (
              <FormControl
                isInvalid={
                  form.errors.numeroResidencia && form.touched.numeroResidencia
                }
                id="numeroResidencia"
              >
                <FormLabel
                  color="#5F6377"
                  fontWeight="500"
                  fontSize="14px"
                  lineHeight="19.6px"
                  htmlFor="numeroResidencia"
                >
                  Número
                </FormLabel>
                <Input
                  {...field}
                  h="42px"
                  name="numeroResidencia"
                  id="numeroResidencia"
                  backgroundColor="#F9FAFB"
                  autoComplete="off"
                  border="1px solid #D7D8DE"
                  placeholder="Informe o Número"
                  maxLength={14}
                  onChange={(e) => {
                    form.setFieldValue(
                      "numeroResidencia",
                      numeroEndereco(e.target.value),
                    );
                  }}
                />
                <FormErrorMessage>
                  {form.errors.numeroResidencia}
                </FormErrorMessage>
              </FormControl>
            )}
          </Field>
        </GridItem>
        <GridItem colSpan={{ base: 6, sm: 6, lg: 2 }}>
          <Field name="cep">
            {({ field, form }) => (
              <FormControl
                isInvalid={form.errors.cep && form.touched.cep}
                id="cep"
              >
                <FormLabel
                  color="#5F6377"
                  fontWeight="500"
                  fontSize="14px"
                  lineHeight="19.6px"
                  htmlFor="cep"
                >
                  CEP*
                </FormLabel>
                <Input
                  {...field}
                  h="42px"
                  name="cep"
                  id="cep"
                  backgroundColor="#F9FAFB"
                  autoComplete="off"
                  border="1px solid #D7D8DE"
                  placeholder="Informe o CEP"
                  guide={false}
                  mask={[/\d/, /\d/, /\d/, /\d/, /\d/, "-", /\d/, /\d/, /\d/]}
                  as={MaskedInput}
                />
                <FormErrorMessage>{form.errors.cep}</FormErrorMessage>
              </FormControl>
            )}
          </Field>
        </GridItem>
        <GridItem colSpan={{ base: 6, sm: 6, lg: 2 }}>
          <Field name="complemento">
            {({ field, form }) => (
              <FormControl
                isInvalid={form.errors.complemento && form.touched.complemento}
                id="complemento"
              >
                <FormLabel
                  color="#5F6377"
                  fontWeight="500"
                  fontSize="14px"
                  lineHeight="19.6px"
                  htmlFor="complemento"
                >
                  Complemento
                </FormLabel>
                <Input
                  {...field}
                  h="42px"
                  name="complemento"
                  id="complemento"
                  backgroundColor="#F9FAFB"
                  autoComplete="off"
                  border="1px solid #D7D8DE"
                  placeholder="Informe o Complemento"
                />
                <FormErrorMessage>{form.errors.complemento}</FormErrorMessage>
              </FormControl>
            )}
          </Field>
        </GridItem>
        <GridItem colSpan={{ base: 6, sm: 6, lg: 2 }}>
          <Field name="pontoReferencia">
            {({ field, form }) => (
              <FormControl
                isInvalid={
                  form.errors.pontoReferencia && form.touched.pontoReferencia
                }
                id="pontoReferencia"
              >
                <FormLabel
                  color="#5F6377"
                  fontWeight="500"
                  fontSize="14px"
                  lineHeight="19.6px"
                  htmlFor="pontoReferencia"
                >
                  Ponto de Referência
                </FormLabel>
                <Input
                  {...field}
                  h="42px"
                  name="pontoReferencia"
                  id="pontoReferencia"
                  backgroundColor="#F9FAFB"
                  autoComplete="off"
                  border="1px solid #D7D8DE"
                  placeholder="Informe o Ponto de Referência"
                />
                <FormErrorMessage>
                  {form.errors.pontoReferencia}
                </FormErrorMessage>
              </FormControl>
            )}
          </Field>
        </GridItem>
        <GridItem colSpan={6}>
          <FormLabel
            color="#5F6377"
            fontWeight="500"
            fontSize="14px"
            lineHeight="19.6px"
            htmlFor="mantenedoras"
          >
            Órgão/Entidade Mantenedora*
          </FormLabel>
          <FieldArray name="mantenedoras">
            {(arrayHelpers) => (
              <Box>
                {formProps.values.mantenedoras &&
                formProps.values.mantenedoras.length > 0 ? (
                  formProps.values.mantenedoras.map((mantenedora, index) => (
                    <Field name={`mantenedoras[${index}].nome`} key={index}>
                      {({ field, form }) => (
                        <FormControl
                          isInvalid={
                            (formProps.errors.mantenedoras
                              ? formProps.errors.mantenedoras[index]?.nome
                              : false) &&
                            (formProps.touched.mantenedoras
                              ? formProps.touched.mantenedoras[index]?.nome
                              : false)
                          }
                          id={`mantenedoras[${index}].id`}
                        >
                          <HStack
                            spacing="10px"
                            w="100%"
                            alignItems="center"
                            mt="8px"
                          >
                            <Input
                              {...field}
                              h="42px"
                              name={`mantenedoras[${index}].nome`}
                              backgroundColor="#fff"
                              autoComplete="off"
                              border="1px solid #D7D8DE"
                              placeholder="Informe o Órgão/Entidade Mantenedora"
                              maxLength={255}
                            />
                            <Icon
                              d={index !== 0 ? "flex" : "none"}
                              aria-label="Excluir orgao mantenedor"
                              color="#9EA1AE"
                              as={IoTrash}
                              boxSize="25px"
                              _hover={{ cursor: "pointer" }}
                              onClick={() => arrayHelpers.remove(index)}
                            />
                          </HStack>
                          <Text mt="8px" color="#e53e3e" fontSize="14px">
                            <ErrorMessage
                              name={`mantenedoras[${index}].nome`}
                            />
                          </Text>
                        </FormControl>
                      )}
                    </Field>
                  ))
                ) : (
                  <div />
                )}

                <Button
                  id="button-adicionar"
                  mt="10px"
                  color="#FFF"
                  backgroundColor="#169499"
                  fontWeight={500}
                  fontSize="13px"
                  lineHeight="21.6px"
                  _hover={{ bg: "#169499" }}
                  onClick={() => {
                    arrayHelpers.push({ id: 0, nome: "" });
                  }}
                >
                  Adicionar
                </Button>
              </Box>
            )}
          </FieldArray>
        </GridItem>
      </Grid>
    </Flex>
  );
};

export default Identificacao;
